import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type IEmployerNode = { id: number; name: string; clientId: number };

type employerState = {
  list: IEmployerNode[] | [];
};

const initialState: employerState = { list: [] };

const slice = createSlice({
  name: "employers",
  initialState,
  reducers: {
    setEmployersList(state, action: PayloadAction<employerState>) {
      state.list = action.payload.list ?? [];
    },
    clearEmployers(state) {
      state.list = [];
    },
  },
});

export const { setEmployersList, clearEmployers } = slice.actions;
export default slice.reducer;
